import { checkIcon } from '@progress/kendo-svg-icons';
import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NexusComponent } from 'app/core/components/nexus/nexus.component';
import { CustomerGroupModel } from 'app/models/customer-group.model';
import { NexusFormResultModel } from 'app/models/nexus-form-result.model';
import { CustomerService } from 'app/services/customer.service';

@Component({
  standalone: false,
  selector: 'customer-group',
  templateUrl: './customer-group.component.html',
  styleUrls: ['./customer-group.component.scss']
})
export class CustomerGroupComponent extends NexusComponent {
  checkIcon = checkIcon;

  @Input() public customer_id: string;
  @Input() public customer_group_id: string;
   public customer_group_model: CustomerGroupModel;
   public respect_move_out_dates: boolean;
   public is_editable: boolean;
  constructor(private router: Router,private service: CustomerService) {
    super();
  }
  public form_result: NexusFormResultModel = new NexusFormResultModel();
  public form = new UntypedFormGroup({
    start_date: this.CreateFormControl(),
    end_date: this.CreateRequiredFormControl(),
    move_out_date: this.CreateRequiredFormControl(),
    modification_note: this.CreateRequiredFormControl()
  });

  ngOnInit(): void {

    this.form.valueChanges.subscribe((form_data: any) => {
      this.PopulateModelFromForm(form_data, this.customer_group_model);
    });

    this.load_customer_group();



  }
  submit() {
    this.form_result.Reset();

    this.SetFormTouched(this.form);
    if (this.form.invalid) {
      this.form_result.Incomplete();
      return;
    }
    
    const today = new Date();
    const future_30_days =new Date(today);
    future_30_days.setDate(today.getDate() + 30);
    const past_30_days =new Date(today);
    past_30_days.setDate(today.getDate() - 30);


    if( !this.respect_move_out_dates && (this.form.get('end_date')?.value < past_30_days || this.form.get('end_date')?.value > future_30_days)){
      this.form_result.Error("Lease End Date should be within 30 days from the Current Date.");
      return;
    }
    if(this.respect_move_out_dates && (this.form.get('move_out_date')?.value < past_30_days || this.form.get('move_out_date')?.value > future_30_days)){
      this.form_result.Error("Move Out Date should be within 30 days from the Current Date.");
      return;
    }

    this.StartSpinner();
    this.service.SaveCustomerGroup(this.customer_group_model.customer_id, this.customer_group_model).subscribe(
      data => {
        this.form_result.Success();
        this.StopSpinner();
        this.navigate_to_groups();
      },
      error => {
        this.form_result.Error(error);
        this.StopSpinner();
      });

  }
  load_customer_group(){
    if(this.customer_id && this.customer_group_id){

      this.StartSpinner();
      this.service.GetCustomerGroup(this.customer_id, this.customer_group_id).subscribe(
        data => {
          this.customer_group_model = data;
          this.form.patchValue(this.customer_group_model);
          this.respect_move_out_dates = this.customer_group_model.property_respect_move_out_dates;
          
          this.form.get('start_date').disable();
          if( this.respect_move_out_dates){
            this.form.get('move_out_date').enable();
            this.form.get('end_date').disable();
          } else{
            this.form.get('move_out_date').disable();
            this.form.get('end_date').enable();
          }

          this.is_editable = !this.customer_group_model.final_portion;
          if(!this.is_editable){
            this.form.disable();
          }
          this.StopSpinner();
       },
        error => {
          this.form_result.Error(error);
          this.StopSpinner();
        });

    }

  }
  navigate_to_groups() {
    this.router.navigate(['/customer', this.customer_id, 'groups']);
  }

}
